/* Toont de yen-prijzen omgerekend in dollars.
 *
 * Dit is puur weergave: de winkel rekent af in yen. De omrekening draait alleen
 * buiten het Japans en alleen als de bezoeker USD gekozen heeft. Bij JPY raakt
 * dit script geen enkel element aan.
 */
(function () {
  var cfg = window.NB_USD;
  if (!cfg || !cfg.koers) return;

  var SLEUTEL = 'nb_valuta';
  var BEDRAG = /[¥￥]\s?(\d{1,3}(?:,\d{3})+|\d+)/g;
  var OVERSLAAN = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, NOSCRIPT: 1, SELECT: 1, OPTION: 1 };
  var bezig = false;

  function keuze() {
    try {
      return localStorage.getItem(SLEUTEL) || cfg.standaard || 'JPY';
    } catch (e) {
      return cfg.standaard || 'JPY';
    }
  }

  function bewaar(v) {
    try { localStorage.setItem(SLEUTEL, v); } catch (e) { /* privemodus: dan geldt het alleen deze pagina */ }
  }

  /* ¥7,999 bij koers 157 -> 50,94 -> $50.99. Onder de vijf dollar gewoon twee decimalen,
     anders krijg je rare sprongen bij kleine bedragen. */
  function naarDollar(yen) {
    var d = yen / cfg.koers;
    if (d < 5) return '$' + d.toFixed(2);
    var heel = Math.max(1, Math.round(d));
    return '$' + (heel - 0.01).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function zetOm(tekst) {
    return tekst.replace(BEDRAG, function (_, getal) {
      return naarDollar(parseInt(getal.replace(/,/g, ''), 10));
    });
  }

  function loop(wortel) {
    if (!wortel || keuze() !== 'USD') return;
    var w = document.createTreeWalker(wortel, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue || n.nodeValue.indexOf('¥') < 0 && n.nodeValue.indexOf('￥') < 0) {
          return NodeFilter.FILTER_REJECT;
        }
        var e = n.parentElement;
        while (e) {
          if (OVERSLAAN[e.tagName] || e.hasAttribute('data-nb-geen-usd')) return NodeFilter.FILTER_REJECT;
          e = e.parentElement;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var knopen = [];
    var n;
    while ((n = w.nextNode())) knopen.push(n);
    if (!knopen.length) return;
    bezig = true;
    knopen.forEach(function (k) {
      var nieuw = zetOm(k.nodeValue);
      if (nieuw !== k.nodeValue) k.nodeValue = nieuw;
    });
    bezig = false;
  }

  function start() {
    loop(document.body);
    /* De winkelwagen en de bundelkiezer tekenen hun prijzen met JavaScript,
       dus we kijken ook naar wat er later bij komt. */
    if (!window.MutationObserver) return;
    new MutationObserver(function (lijst) {
      if (bezig || keuze() !== 'USD') return;
      for (var i = 0; i < lijst.length; i++) {
        var m = lijst[i];
        if (m.type === 'characterData') {
          var e = m.target.parentElement;
          if (e) loop(e);
        } else {
          for (var j = 0; j < m.addedNodes.length; j++) {
            var a = m.addedNodes[j];
            if (a.nodeType === 1) loop(a);
            else if (a.nodeType === 3 && a.parentElement) loop(a.parentElement);
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  function kies(v) {
    bewaar(v);
    location.reload();
  }

  function koppel() {
    var sel = document.querySelector('[data-nb-valuta]');
    if (sel) {
      sel.value = keuze();
      sel.addEventListener('change', function () { kies(sel.value); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { start(); koppel(); });
  } else {
    start();
    koppel();
  }
})();
